import styled from 'styled-components'
import { themeGet } from 'styled-system'

/**
 * Shared layout styles for class drawer headers.
 * This provides the base wrapper structure and styling that all context-specific headers use.
 * Headers should import ContentWrapper and TitleWrapper from their own styles or from ReportsClassHeader
 * if they need the same structure.
 */
export const ClassHeaderWrapper = styled.div.attrs(props => {
  const { fixedTop, fixedView } = props
  return {
    boxShadow: fixedView
      ? `0 4px 4px ${themeGet('colors.grayBlue')(props)}`
      : 'none',
    padding: fixedView
      ? '1.5rem 1.25rem 1.375rem 1.25rem'
      : '2.125rem 1.25rem 1.3rem 1.25rem',
    paddingTop: fixedView ? '1.5rem' : fixedTop ? '0' : '32px',
    position: fixedTop ? 'fixed' : 'relative',
    zIndex: fixedView ? 200 : -1,
  }
})`
  display: flex;
  flex-direction: column;
  width: 746px;
  position: ${({ position }) => position};
  padding: ${({ padding }) => padding};
  padding-top: ${({ paddingTop }) => paddingTop};
  background: ${themeGet('colors.white')};
  box-shadow: ${({ boxShadow }) => boxShadow};
  z-index: ${({ zIndex }) => zIndex};
  ${themeGet('breakpoints.mobileLarge')} {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 1.375rem;
  }
`

// Export shared layout components for use in context-specific headers
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
  ${themeGet('breakpoints.mobileLarge')} {
    width: 90%;
  }
  ${themeGet('breakpoints.mobile')} {
    width: 100%;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-end;
  width: 100%;
`
